import axios from 'axios';

const server = axios.create({
  baseURL: `${process.env.REACT_APP_SOA_API_URL}/api`,
});

export default server;
